export default __webpack_public_path__ + "194afb5c836e489ea855df949c82f30d.png";